module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Tips & tricks</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  })]), _vm._v(" "), (_vm.tips.length) ? _c('div', _vm._l((_vm.tips.filter(function (x) { return x.tips.length; })), function(tipGroup) {
    return _c('div', {
      key: tipGroup.group,
      staticClass: "tip__group"
    }, [_c('div', {
      staticClass: "tip__group__headline"
    }, [(tipGroup.group === 'Overblik') ? _c('i', {
      staticClass: "fas fa-th-large fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Mulige indsatser') ? _c('i', {
      staticClass: "fas fa-clock fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Økonomi') ? _c('i', {
      staticClass: "fas fa-wallet fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Kunder') ? _c('i', {
      staticClass: "fas fa-briefcase fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Opgaver') ? _c('i', {
      staticClass: "fas fa-clipboard-list-check fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Medarbejdere') ? _c('i', {
      staticClass: "fas fa-users fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Ansvarlige') ? _c('i', {
      staticClass: "fas fa-user-hard-hat fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Potentiale') ? _c('i', {
      staticClass: "fas fa-star fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Indstillinger') ? _c('i', {
      staticClass: "fas fa-cog fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Entreprise') ? _c('i', {
      staticClass: "fas fa-tools fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Læg budget') ? _c('i', {
      staticClass: "fas fa-money-check-edit-alt fa-fw"
    }) : _vm._e(), _vm._v("\n                     \n                    " + _vm._s(tipGroup.group) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "tip__wrapper"
    }, _vm._l((tipGroup.tips), function(tip, index) {
      return _c('div', {
        key: ((tipGroup.group) + "_" + index),
        staticClass: "tip__single"
      }, [_c('div', {
        staticClass: "inner",
        class: {
          'show': _vm.show === tip.id
        }
      }, [_c('div', {
        staticClass: "headline",
        on: {
          "click": function($event) {
            _vm.show === tip.id ? _vm.show = null : _vm.show = tip.id
          }
        }
      }, [_c('div', {
        staticClass: "left"
      }, [_vm._v("\n                                    " + _vm._s(tip.headline) + "\n                                ")]), _vm._v(" "), _c('div', {
        staticClass: "right"
      }, [(_vm.show !== tip.id) ? _c('i', {
        staticClass: "fas fa-plus fa-fw"
      }) : _vm._e(), _vm._v(" "), (_vm.show === tip.id) ? _c('i', {
        staticClass: "fas fa-minus fa-fw"
      }) : _vm._e()])]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.show === tip.id),
          expression: "show === tip.id"
        }],
        staticClass: "content",
        domProps: {
          "innerHTML": _vm._s(tip.content)
        }
      })])])
    }), 0)])
  }), 0) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06756f52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/tips.vue
// module id = 791
// module chunks = 0